const OSCMS = () => {
  return <h1>OSCMS</h1>
}

export default OSCMS
